import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import download from '../images/download-doc.svg';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import { Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.mode === "light"
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)'
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)'
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    backgroundColor: '#00a7e1',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#6cca98',
      color: '#fff',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
});

class EnhancedTableToolbar extends React.Component {
  render() {
    const {
      NumRowsSelected,
      classes,
      OnConfirmDeleteUser,
      SearchText,
      OnHanleSerachTextInput,
      OnGenerateCSVReport,
      IsButtonDisabled,
      t,
      queryId, groups, handleInputChange
    } = this.props;

    return (
      <React.Fragment>
        <Toolbar
          className={classNames(classes.root, {
            [classes.highlight]: NumRowsSelected > 0,
          })}>
          <div className={classes.title}>
            {NumRowsSelected > 0 ? (
              <Typography color='inherit' variant='subheading'>
                {NumRowsSelected} {t("Report.inActive.SelectedRowCount")}
              </Typography>
            ) : (
              <div style={{ width: "223%" }}>
                <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-evenly'} spacing={0} sx={{ mt: '1rem', ml: 0, width: '100%', p: '0% 2% 1%' }}>
                  <Grid item xs={3} md={3}>
                    <FormControl fullWidth>
                      <TextField
                        label={t("Report.inActive.Search")}
                        onChange={OnHanleSerachTextInput}
                        id='idsearchtxt'
                        className={classes.formControl}
                        defaultValue=''
                        value={SearchText}
                        style={{ width: '200%' }}
                        variant="standard"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3} md={3}>
                    <FormControl
                      variant='standard'
                      sx={{ m: '16px 0', minWidth: 347 }}
                    >
                      <InputLabel id='preferred-group-label'>
                        {t('Group.User.GroupControlTitle')}
                      </InputLabel>
                      <Select
                        labelId='preferred-group-label'
                        id='preferred-group-select-standard'
                        value={queryId}
                        onChange={handleInputChange}
                        variant='standard'
                        label={t('Group.User.GroupControlTitle')}
                      >
                        {groups.length > 0 &&
                          groups.map((type, index) => (
                            <MenuItem
                              key={index}
                              value={type.id}
                              className={classes.locationType}
                            >
                              {type.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
            )}
          </div>
          <div className={classes.spacer} />
          <div className={classes.actions}>
            {NumRowsSelected === 1 ? (
              <div>
                <Tooltip key='single-delete' title={t("Report.inActive.DeleteTooltip")}>
                  <IconButton aria-label='Delete' onClick={OnConfirmDeleteUser}
                    sx={() => ({ '&:hover': { backgroundColor: '#6cca98', color: '#fff' } })}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </div>
            ) : NumRowsSelected > 1 ? (
              <Tooltip key='multi-delete' title={t("Report.inActive.DeleteTooltip")}>
                <IconButton aria-label='Delete' onClick={OnConfirmDeleteUser}
                  sx={() => ({ '&:hover': { backgroundColor: '#6cca98', color: '#fff' } })}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <React.Fragment>
                <div style={{ display: 'flex' }}>
                  <Tooltip key='exportcsv' title={t("Report.inActive.ExportCSVTooltip")}>
                    <IconButton
                      style={{ marginRight: '0' }}
                      aria-label='ExportCSV'
                      onClick={OnGenerateCSVReport}
                      disabled={IsButtonDisabled}>
                      <img
                        alt='download'
                        src={download}
                        style={{
                          height: '32px',
                          width: '32px',
                          cursor: 'pointer',
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  {/* <Tooltip key='exportpdf' title='ExportPDF'>
                    <IconButton
                      style={{ marginRight: '0' }}
                      aria-label='ExportPDF'
                      >
                      <img
                        alt='download'
                        src={downloadPDF}
                        style={{
                          height: '32px',
                          width: '32px',
                          cursor: 'pointer',
                        }}
                      />
                    </IconButton>
                  </Tooltip> */}
                </div>
              </React.Fragment>
            )}
          </div>
        </Toolbar>
      </React.Fragment>
    );
  }
}

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  NumRowsSelected: PropTypes.number.isRequired,
};

export default withStyles(toolbarStyles)(withTranslation()(EnhancedTableToolbar));



// WEBPACK FOOTER //
// ./src/components/reports/users-inactive-report/EnhancedTableToolBar.index.js